import Post, {IPost} from '@/models/Post'

export interface INews extends IPost {
}

export default class News extends Post {
  constructor(defaults?: INews) {
    super(defaults)
    if (defaults) {
    }
  }

  get className(): string {
    return News.name
  }
}
